<template>
  <div>صفحه راهنمایی استفاده</div>
</template>

<script>
export default {
  name: "UsageTips"
}
</script>

<style scoped>

</style>